(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["MapsCandy"] && !window.DesignMode) return;
  try {
    

  let stores_chiapas = ['Candy Ambar Tuxtla','Candy Comitan','Candy Comitan Centro','Candy Comitan Portales','Candy Galerias Tapachula','Candy Galerias Tuxtla','Candy Tuxtla Central Sur','Candy Tuxtla Poniente','Candy Plaza San Cristobal','Candy Plaza Cristal Tuxtla'];
  let stores_morelos = ['Candy Cuautla','Candy Cuautla Centro'];
  let stores_oaxaca = ['Candy 20 de Noviembre','Candy Las Casas','Candy Macroplaza','Candy Plaza Bella','Candy Plaza Del Valle','Candy Plaza Huatulco','Candy Puerto Escondido','Candy Reforma','Candy Salina Cruz','Candy Soriana','Candy Hidalgo'];
  let stores_puebla = ['Candy Via San Angel'];

  let C_20_NOV   = '<iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d674.275601122511!2d-96.72713630446903!3d17.059010082723745!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xae11dbcd548e5d2a!2sCandy+Zapater%C3%ADas!5e0!3m2!1ses!2smx!4v1493144746017" width="100%" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>';
  let C_AMBAR_T  = '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1910.3050748422158!2d-93.07474174211032!3d16.746292765574953!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85ed27a0c0c13819%3A0x87293dd082c6bc94!2sZapater%C3%ADas+Candy+Ambar!5e0!3m2!1ses-419!2smx!4v1506446409081" width="100%" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>';
  let C_BARATA   = '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d953.4817300720886!2d-96.71664237076769!3d17.076226981248755!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85c7222f73712169%3A0x5d0a0653fafb5e1b!2sEmilio%20Carranza%20413%2C%20Reforma%2C%2068050%20Oaxaca%20de%20Ju%C3%A1rez%2C%20Oax.!5e0!3m2!1ses-419!2smx!4v1650643099131!5m2!1ses-419!2smx" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>';
  let C_COMITAN  = '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d677.2424292283501!2d-92.11439494918731!3d16.217266724809825!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x75a6ddf2acd34118!2sZapaterias+Candy!5e0!3m2!1ses-419!2smx!4v1501883652755" width="100%" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>';
  let C_COMI_C   = '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3830.3841094247377!2d-92.13677808462043!3d16.252072538827456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x858d38b0176276e3%3A0xb0a12358f9e1e42e!2sPrimera%20Avenida%20Ote.%20Sur%205%2C%20Centro%2C%2030000%20Comit%C3%A1n%20de%20Dom%C3%ADnguez%2C%20Chis.!5e0!3m2!1ses-419!2smx!4v1650641656998!5m2!1ses-419!2smx" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>';
  let C_COMI_P   = '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3830.3865708056037!2d-92.13789018462042!3d16.251946238830904!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x858d38afe7a5323b%3A0x315e8ae3cd4155fc!2sAv.%20Central%20Sur%20Dr.%20B.%20Dominguez%2025%2C%20Centro%2C%2030000%20Comit%C3%A1n%20de%20Dom%C3%ADnguez%2C%20Chis.!5e0!3m2!1ses-419!2smx!4v1650642561788!5m2!1ses-419!2smx" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>';
  let C_CUAUTLA  = '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d235.9635327666192!2d-98.94947652375681!3d18.86859417931289!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x9eaf865b4435bee4!2sZapater%C3%ADas+Candy!5e0!3m2!1ses-419!2smx!4v1502492418804" width="100%" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>';
  let C_GAL_TAPA = '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1928.0610185691357!2d-92.28372187948041!3d14.874452920892587!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x858e0fd9f2829f99%3A0x96df42ee2e5b0b17!2sZapaterias+Candy+Galerias+Tapachula!5e0!3m2!1ses-419!2smx!4v1526316039768" width="100%" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>';
  let C_GAL_TUX  = '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3212.6919066296987!2d-93.15143677473205!3d16.748987681524973!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85ecd90f40a5676f%3A0x1e5b42fc51a6f227!2sGaler%C3%ADas%20Boulevard!5e0!3m2!1ses-419!2smx!4v1650642832605!5m2!1ses-419!2smx" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>';
  let C_CASAS    = '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2267.961896474298!2d-96.7336166731333!3d17.060808608246766!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85c72214b3194df3%3A0x295dcfc00f2508a9!2sZapater%C3%ADas+Candy!5e0!3m2!1ses-419!2s!4v1506790734731" width="100%" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>';
  let C_MACRO    = '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3814.1048168497036!2d-96.6967879851281!3d17.067524888271013!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85c723c60ad83531%3A0x3ee9db340161b0d8!2sZapater%C3%ADas+Candy!5e0!3m2!1ses-419!2s!4v1506791028873" width="100%" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>';
  let C_P_TEX    = '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1581.140984064019!2d-98.86724502753877!3d19.51548463506741!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d1e7b9d5544a3d%3A0x85d4d50268b6e607!2sGran+Patio+Texcoco!5e0!3m2!1ses-419!2smx!4v1501858320667" width="100%" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>';
  let C_BELLA    = '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d476.7451712560395!2d-96.75874000609755!3d17.074542152457195!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85c718af0390cf35%3A0x5e2bc928dbe0c699!2sZapater%C3%ADas+Candy!5e0!3m2!1ses-419!2s!4v1493911765017" width="100%" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>';
  let C_VALLE    = '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d238.4180759001185!2d-96.71230351731913!3d17.03890780425105!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x1a689bbabc6ef28e!2sZapaterias+Candy!5e0!3m2!1ses-419!2smx!4v1501887491495" width="100%" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>';
  let C_HUATULCO = '<iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d678.7851388288522!2d-96.12861202890609!3d15.762318830423698!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xe23e739448f2ff36!2szapaterias+candy!5e0!3m2!1ses-419!2smx!4v1501858497938" width="100%" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>';
  let C_PUERTO_E = '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3837.7524835022523!2d-97.07507998483142!3d15.869601148971386!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85b8f72328ca3de3%3A0xbac0f10aca2f322a!2sZapaterias+Candy!5e0!3m2!1ses-419!2smx!4v1542063355125" width="100%" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>';
  let C_REFORMA  = '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3813.918879323561!2d-96.71834838461463!3d17.07662021618684!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85c7222f72694295%3A0x2985c6dbe2807587!2sC.%20Palmeras%20223%2C%20Reforma%2C%2068050%20Oaxaca%20de%20Ju%C3%A1rez%2C%20Oax.!5e0!3m2!1ses-419!2smx!4v1650643233795!5m2!1ses-419!2smx" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>';
  let C_SALINA_C = '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d478.84713418832735!2d-95.20924006608163!3d16.23189639665196!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x64f34df6833209fe!2sZapaterias+candy+salina+cruz!5e0!3m2!1ses-419!2smx!4v1501858641615" width="100%" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>';
  let C_SORIANA  = '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d801.9242638846847!2d-96.71573207339894!3d17.04248766047922!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85c7223bd5dde465%3A0xedb42c1e3ca7b0b4!2sZapater%C3%ADas+Candy!5e0!3m2!1ses-419!2s!4v1506790978996" width="100%" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>';
  let C_CENTR_S  = '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1135.8440913809493!2d-93.11705698731373!3d16.751338324857326!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85ecd88b3e000f3b%3A0x7d240bf775a09dcc!2sC.%20Central-Sur%20365%2C%20Asamblea%20de%20barrio%2C%20San%20Roque%2C%2029040%20Tuxtla%20Guti%C3%A9rrez%2C%20Chis.!5e0!3m2!1ses-419!2smx!4v1650642079350!5m2!1ses-419!2smx" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>';
  let C_TUX_PON  = '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d955.1166161620071!2d-93.11753247076783!3d16.75345248345911!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85ecd88ca67c593b%3A0xcbf874e96fa4fde6!2sCalle%20Primera%20Pte.%20Sur%20121%2C%20El%20Calvario%2C%2029066%20Tuxtla%20Guti%C3%A9rrez%2C%20Chis.!5e0!3m2!1ses-419!2smx!4v1650642013317!5m2!1ses-419!2smx" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>';
  let C_UP_TOWN  = '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d329.20325559003345!2d-89.58290005364859!3d21.012283367229767!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x9c0ae5fd882ab50a!2sCandy+Zapaterias!5e0!3m2!1ses-419!2smx!4v1501859090831" width="100%" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>';
  let C_SAN_ANGE = '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1333.5482950126368!2d-98.2376369607279!3d19.026587130989824!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85cfc74748e45ff3%3A0xd68cd51a1ecb0c44!2sPlaza+Via+San+Angel+Puebla!5e0!3m2!1ses-419!2smx!4v1501859215950" width="100%" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>';

  let C_CRI_TUXT = '<iframe src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d5402.939280638915!2d-93.15038126606181!3d16.754023446991166!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1splaza%20crystal%20tuxtla!5e0!3m2!1ses-419!2smx!4v1681919485628!5m2!1ses-419!2smx" width="100%" height="450" style="border:0;" allowfullscreen></iframe>';
  let C_PSCRISTO = '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1350.8764314987593!2d-92.65284946169787!3d16.734058218020692!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85ed450c43425ea5%3A0x3bad9c7563c4532b!2sDiagonal%20Hermanos%20Paniagua%2050%2C%20Sta%20Lucia%2C%2029240%20San%20Crist%C3%B3bal%20de%20las%20Casas%2C%20Chis.!5e0!3m2!1ses-419!2smx!4v1681919556821!5m2!1ses-419!2smx" width="100%" height="450" style="border:0;" allowfullscreen></iframe>';
  let CANDYHIDAL = '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3814.241547252205!2d-96.72901305469627!3d17.060833576399055!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85c7223f628ec4c5%3A0xebc9c8091f0b9769!2sMiguel%20Hidalgo%20814%2C%20Centro%2C%2068000%20Oaxaca%20de%20Ju%C3%A1rez%2C%20Oax.!5e0!3m2!1ses-419!2smx!4v1681929315813!5m2!1ses-419!2smx" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>';
  let CCUAU_CENT = '<iframe src="https://www.google.com/maps/embed?pb=!3m2!1ses-419!2smx!4v1681918758608!5m2!1ses-419!2smx!6m8!1m7!1ssygj554QRPhjCBD4ImlDOw!2m2!1d18.81457029154447!2d-98.95414746464631!3f24.683968903727486!4f8.392702484033109!5f0.7820865974627469" width="100%" height="450" style="border:0;" allowfullscreen></iframe>';
  
  let selectState    =  document.getElementById('my-state');
  let select         =  document.getElementById('my-location');
  document.getElementById("map").innerHTML = C_20_NOV;


  selectState.addEventListener('change', function(event){    
    emptySelectBoxById('my-location', null, 'Selecciona un estado');
    getLocations(event.target.value);
  });


  function emptySelectBoxById(elementId, optionValue, optionText) {
      document.getElementById(elementId).innerHTML = `
          <option value="${optionValue}">${optionText}</option>
      `;
  }

  function getLocations(location) {
       switch (event.target.value) {
        case 'Chiapas':
          $.each(stores_chiapas, function(i, value) {
            $('#my-location').append($('<option>').text(value).attr('value', value));
          });
          break;
        case 'Morelos':
           $.each(stores_morelos, function(i, value) {
            $('#my-location').append($('<option>').text(value).attr('value', value));
          });
          break;
        case 'Oaxaca':
         $.each(stores_oaxaca, function(i, value) {
            $('#my-location').append($('<option>').text(value).attr('value', value));
          });
          break;
        case 'Puebla':
           $.each(stores_puebla, function(i, value) {
            $('#my-location').append($('<option>').text(value).attr('value', value));
          });
          break;
        default:
          console.log('default');
      }

  }
  
  select.addEventListener('change', function(event){
    let location = event.target.value;
    console.log(location);

    if (location === 'Candy 20 de Noviembre') {
        document.getElementById("map").innerHTML = C_20_NOV;
    }
    if (location === 'Candy Ambar Tuxtla') {
        document.getElementById("map").innerHTML = C_AMBAR_T;
    } 
    if (location === 'Candy Barata') {
        document.getElementById("map").innerHTML = C_BARATA;
    } 
    if (location === 'Candy Comitan') {
        document.getElementById("map").innerHTML = C_COMITAN;
    } 
    if (location === 'Candy Comitan Centro') {
        document.getElementById("map").innerHTML = C_COMI_C;
    } 
    if (location === 'Candy Comitan Portales') {
        document.getElementById("map").innerHTML = C_COMI_P;
    } 
    if (location === 'Candy Cuautla') {
        document.getElementById("map").innerHTML = C_CUAUTLA;
    } 
    if (location === 'Candy Galerias Tapachula') {
        document.getElementById("map").innerHTML = C_GAL_TAPA;
    } 
    if (location === 'Candy Galerias Tuxtla') {
        document.getElementById("map").innerHTML = C_GAL_TUX;
    } 
    if (location === 'Candy Las Casas') {
        document.getElementById("map").innerHTML = C_CASAS;
    } 
    if (location === 'Candy Macroplaza') {
        document.getElementById("map").innerHTML = C_MACRO;
    } 
    if (location === 'Candy Moraleda Atlixco') {
        document.getElementById("map").innerHTML = C_M_ATLIXC;
    } 
    if (location === 'Candy Patio Texcoco') {
        document.getElementById("map").innerHTML = C_P_TEX;
    } 
    if (location === 'Candy Plaza Bella') {
        document.getElementById("map").innerHTML = C_BELLA;
    } 
    if (location === 'Candy Plaza Del Valle') {
        document.getElementById("map").innerHTML = C_VALLE;
    } 
    if (location === 'Candy Plaza Huatulco') {
        document.getElementById("map").innerHTML = C_HUATULCO;
    } 
    if (location === 'Candy Puerto Escondido') {
        document.getElementById("map").innerHTML = C_PUERTO_E;
    } 
    if (location === 'Candy Reforma') {
        document.getElementById("map").innerHTML = C_HUATULCO;
    } 
    if (location === 'Candy Salina Cruz') {
        document.getElementById("map").innerHTML = C_SALINA_C;
    } 
    if (location === 'Candy Soriana') {
        document.getElementById("map").innerHTML = C_SORIANA;
    } 
    if (location === 'Candy Tuxtla Central Sur') {
        document.getElementById("map").innerHTML = C_CENTR_S;
    } 
    if (location === 'Candy Tuxtla Poniente') {
        document.getElementById("map").innerHTML = C_TUX_PON;
    } 
    if (location === 'Candy Up Town Merida') {
        document.getElementById("map").innerHTML = C_UP_TOWN;
    } 
    if (location === 'Candy Via San Angel') {
        document.getElementById("map").innerHTML = C_SAN_ANGE;
    }
    if (location === 'Candy Plaza Cristal Tuxtla') {
        document.getElementById("map").innerHTML = C_CRI_TUXT;
    }
    if (location === 'Candy Plaza San Cristobal') {
        document.getElementById("map").innerHTML = C_PSCRISTO;
    }
    if (location === 'Candy Hidalgo') {
        document.getElementById("map").innerHTML = CANDYHIDAL;
    }
    if (location === 'Candy Cuautla Centro') {
        document.getElementById("map").innerHTML = CCUAU_CENT;
    }
  });



  
 //     $.ajax({
 //        type: 'GET',
 //        crossDomain: true,
 //        async: true,
 //        cache: false,
 //        headers: { 
 //         'Content-Type': 'application/json;',
 //         'Authorization': "",
 //         'Access-Control-Allow-Origin':'*'
 //        },
 //        url: `https://zapateriascandy.shoes/candy_api/search_location`,
 //        data : params,
 //        dataType: 'jsonp',
 //        success: function(response) {
 //          console.log('response');
 //            return response;
 //        },
 //        complete: function(response) {
 //         console.log(response);
 //          return;
 //            response = response.responseJSON;
 //            console.log(response);
 //            $.each(response, function(i, value) {
 //                $('#my-location').append($('<option>').text(value.name).attr('value', value.name));
 //            });
 //        },
 //        error: function(error) {
 //            console.log('Error: ' + error.status);
 //        }
 //    });

    document.addEventListener("DOMContentLoaded", function() {

    // Datos que quieres enviar en la solicitud POST
      
     const data = {
        param1: 'valor1',
        param2: 'valor2'
    };

    // Realiza la solicitud POST al endpoint en PHP usando Axios
    axios.post('https://zapateriascandy.shoes/candy_api/search_location', data)
    .then(function (response) {
        // Procesa la respuesta
        console.log(response);
        // if (response.data.status === 'success') {
        //     // Haz algo con los datos recibidos
        //     console.log('Datos recibidos:', response.data.data);
        // } else {
        //     console.error('Error en la respuesta:', response.data.message);
        // }
    })
    .catch(function (error) {
        console.error('Error en la solicitud:', error);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
